import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const PeriodDropdown = ({ periods, value, onChange }) => (
  <Select
    value={value ?? undefined}
    onChange={onChange}
    style={{ width: '100%' }}
    placeholder="Select a period"
    allowClear
    showSearch
    optionFilterProp="children"
    filterOption={(input, option) =>
      option.children.toLowerCase().includes(input.toLowerCase())
    }
  >
    {periods.map(period => (
      <Option key={period.id} value={period.id}>
        {period.name}
      </Option>
    ))}
  </Select>
);

export default PeriodDropdown;
